var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.selectedUserGroupComponent,_vm._b({tag:"component",attrs:{"seletedUserGroupName":_vm.selectedUserGroupInfo.group_name},on:{"changeSelectedComponent":_vm.changeSelectedComponent}},'component',_vm.currentProperties,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }